import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "mHead",
  computed: {
    ...walletVuex.mapState(["isMobile"])
  },
  data() {
    return {
      menu: [],
      isPopMenuShow: false,
      showHead: 0,
      ticking: false,
      // 节流标记
      scrollValue: 0
    };
  },
  watch: {
    "$route.path": {
      handler(path) {
        let menu = [];
        if (path == "" || path == "/") {
          menu = [{
            label: this.$lang("About"),
            id: "About"
          }, {
            label: this.$lang("Card"),
            id: "Card"
          }, {
            label: this.$lang("Scenarios"),
            id: "Scenarios"
          }, {
            label: this.$lang("Safe"),
            id: "Safe"
          }, {
            label: this.$lang("General"),
            id: "General"
          }
          // { label: this.$lang("Api"), id: "api" },
          ];
        } else if (path == "/api") {
          menu = [{
            label: this.$lang("Home"),
            id: "home"
          }, {
            label: this.$lang("Api"),
            id: "api"
          }];
        }
        this.menu = menu;
        console.log(333);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    showPopMenu() {
      this.isPopMenuShow = !this.isPopMenuShow;
    },
    onMenu(item) {
      if (item.id == "api") {
        this.$router.push(`/${item.id}`);
        return;
      }
      if (item.id == "home") {
        this.$router.push(`/`);
        return;
      }
      this.isPopMenuShow = false;
      const target = document.getElementById(item.id);
      if (target) {
        target.scrollIntoView({
          behavior: "smooth"
        }); // 平滑滚动
      }
    },

    showPopMenu() {
      this.isPopMenuShow = !this.isPopMenuShow;
    },
    handleScroll() {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          const st = window.scrollY || window.scrollTop;
          console.log("ststst", st);
          if (st <= 10 || st == undefined || st == null) {
            this.showHead = 0;
          } else if (st < this.scrollValue && st >= 200) {
            this.showHead = 1;
          } else {
            this.showHead = -1;
          }
          this.isPopMenuShow = false;
          this.scrollValue = st;
          this.ticking = false;
        });
        this.ticking = true;
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    document.body.addEventListener("click", this.globalClick);
  },
  beforeDestroy() {
    window.addEventListener("scroll", this.handleScroll);
    document.body.addEventListener("click", this.globalClick);
  }
};